import type { DownloadedFile } from './types';

/** How long the object URL stays valid after the click - long enough for slow browsers/AV scanners to start the
 * download, short enough not to leak the blob for the whole session. */
const REVOKE_AFTER_MS = 10_000;

/** Saves a fetched file through an anchor click. The bytes came from an authenticated fetch (cookie auth), so
 * no public URL is ever exposed. */
export function saveDownloadedFile(file: DownloadedFile): void {
  const url = URL.createObjectURL(file.blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = file.fileName;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
